import React, { Component, useContext } from 'react';
import { Container, Col } from 'react-bootstrap';
import { NavMenu } from './NavMenu';
import Sidebar from './Sidebar';
import TabletContainer from './TabletContainer'
import '../../index.css'
import { useAppContext } from '../../Context'
import MenuButton from './MenuButton';
import PowerButton from './PowerButton';

const Layout = ({ children }) => {
    const { isAuthenticated } = useAppContext()

    return (
        <div className="tabletContainer">
            {/*{isAuthenticated ? <NavMenu /> : null}*/}
            {/*{isAuthenticated ? <Sidebar /> : null}*/}
            {isAuthenticated ? <TabletContainer /> : null}
            {/*<Container className="container-body">*/}
                {children}
            {/*</Container>*/}
            {isAuthenticated ? <MenuButton /> : null}
            {isAuthenticated ? <PowerButton /> : null}
        </div>
    );
}

export { Layout }
